import { XServiceType } from "../../../../x-components/XServiceType";
import { DraftVM } from "./DraftVM";

export default function StepInspectionType({ vm }: { vm: DraftVM }) {
  return <XServiceType val$={vm.serviceType$} />;
}
